import { z } from 'zod'
import { nullableArray, OptionalString, SlotSchema, toInterval, WarningSchema } from '@/shared/api'
import type { Interval } from '@/shared/lib'

/**
 * Дело (`schedule.Task`). Без интервала дело живёт списком и в сетку не
 * попадает. Пересечения разрешены — наложение даёт предупреждение, не отказ.
 * Состояния «отменено» нет: удаление физическое.
 */
export const TaskSchema = z
  .object({
    id: z.uuid(),
    title: z.string(),
    slot: SlotSchema.nullish(),
    assignees: nullableArray(z.uuid()),
    done: z.boolean(),
    excursion_id: OptionalString,
    note: z.string().optional().default(''),
  })
  .transform((dto) => ({
    id: dto.id,
    title: dto.title,
    slot: dto.slot ? toInterval(dto.slot) : null,
    assigneeIds: dto.assignees,
    done: dto.done,
    excursionId: dto.excursion_id,
    note: dto.note,
  }))

export interface Task {
  id: string
  title: string
  slot: Interval | null
  assigneeIds: string[]
  done: boolean
  excursionId: string | null
  note: string
}

export const TaskResultSchema = z.object({
  task: TaskSchema,
  warnings: nullableArray(WarningSchema),
})

export const ScheduleSchema = z
  .object({
    tasks: nullableArray(TaskSchema),
    /** Дела без времени — отдельной группой, они не часть сетки. */
    untimed: nullableArray(TaskSchema),
  })
  .transform((dto) => ({ items: dto.tasks, untimed: dto.untimed }))

export interface TaskDraft {
  title: string
  slot: Interval | null
  assigneeIds: string[]
  excursionId: string | null
  note: string
}

export interface TaskPatch {
  title?: string
  /** null — снять время: дело уезжает из сетки в список. */
  slot?: Interval | null
  assigneeIds?: string[]
  excursionId?: string | null
  note?: string
  done?: boolean
}
